import { useTranslation } from '@pypestream/translations';
import type { ExistingItem } from '@pypestream/ui-patterns';
import { useCallback } from 'react';

import type { OrgSecretScope } from './maestro-org-api';

export const secretsKey = (name: string) =>
  `manager/organizations:orgTabs.secrets.${name}`;

export type SecretsText = (
  name: string,
  options?: Record<string, unknown>
) => string;

/** The tab's strings as plain text: its keys are built at runtime, so `t` cannot type them. */
export function useSecretsText(): SecretsText {
  const { t } = useTranslation();
  return useCallback(
    (name, options) => String(t(secretsKey(name), options ?? {})),
    [t]
  );
}

export function scopeLabel(text: SecretsText, scope: OrgSecretScope): string {
  const named =
    scope.type === 'agent'
      ? scope.agent
      : scope.type === 'application'
        ? scope.application
        : scope.type === 'project'
          ? scope.project
          : null;
  return named
    ? text(`scope.${scope.type}`, { name: named.name })
    : text('scope.org');
}

/** A refused name, naming the item that holds it and where, unless that is a child org. */
export function takenMessage(text: SecretsText, existing: ExistingItem) {
  return existing.where === null || existing.scopeType === 'child_org'
    ? text('modal.errors.takenHidden', { name: existing.name })
    : text('modal.errors.taken', {
        name: existing.name,
        scope: text(`modal.errors.scopeWord.${existing.scopeType}`),
        where: existing.where,
      });
}
